import { apiClient } from './client';

export interface FiscalYearDto {
  fiscalYearId: number;
  fiscalYearCode: string;
  fiscalYearDesc?: string;
  isActive: boolean;
  createdBy: number;
  createdByName: string;
  createdOn: string;
  modifiedBy?: number;
  modifiedByName?: string;
  modifiedOn?: string;
}

export interface CreateFiscalYearRequest {
  fiscalYearCode: string;
  fiscalYearDesc?: string;
}

export interface UpdateFiscalYearRequest {
  fiscalYearDesc?: string;
  isActive: boolean;
}

export const fiscalYearsApi = {
  list: async () => await apiClient.get<FiscalYearDto[]>('/api/fiscal-years'),
  getById: async (id: number) => await apiClient.get<FiscalYearDto>(`/api/fiscal-years/${id}`),
  create: async (request: CreateFiscalYearRequest) => 
    await apiClient.post<FiscalYearDto>('/api/fiscal-years', request),
  update: async (id: number, request: UpdateFiscalYearRequest) =>
    await apiClient.put<FiscalYearDto>(`/api/fiscal-years/${id}`, request),
};
